import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import blogsData from '../data/blogs.json';
import ShopByConcern from '../components/ShopByConcern';
import Productlistcard from '../components/Productlistcard';
import ShopByCategory from '../components/ShopByCategory';
import LatestBlogs from '../components/blog/LatestBlogs';

const BlogDetailPage = () => {
    const { slug } = useParams();
    const [Mainblog, setMainblog] = useState(null);
  
    useEffect(() => {
      const selectedBlog = blogsData.find((b) => b.slug === slug);
      setMainblog(selectedBlog);
    }, [slug]);
  
    if (!Mainblog) {
      return <div>Blog not found</div>;
    }
    
    console.log(Mainblog.coverImage);
    return (
      <section>
        <div className="container mx-auto px-4 py-8 md:px-24 md:py-12 lg:w-4/5">
          <img src={Mainblog.coverImage} alt={Mainblog.title}/>
          <h1 className="text-3xl font-bold mb-4">{Mainblog.title}</h1>
          <p className="text-xs text-gray-400 mb-4">{new Date(Mainblog.date).toLocaleDateString()}</p>
          <p className="text-lg text-gray-800">{Mainblog.description}</p>
          {/* Full blog content */}
          <div
          className="blog-content mt-6"
          dangerouslySetInnerHTML={{ __html: Mainblog.content }}
          />        
        </div>
        <LatestBlogs/>
        <ShopByConcern/>
        <div className="container mx-auto mt-12">
          <h2 className="text-2xl md:text-2xl font-bold mb-4 text-center">Our Products</h2>
          <Productlistcard/>
        </div>
        <ShopByCategory/>
      </section>
    );
  };
  
  export default BlogDetailPage;
